import React, { memo } from 'react';

import { map } from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Select, MenuItem } from '@mui/material';

const useStyles = makeStyles(() => ({
  customInputLabel: {
    '& legend': {
      visibility: 'visible',
    },
  },
}));

const Dropdown = ({
  text,
  value,
  items,
  label,
  onChange,
  placeholder,
  selectedValue,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Select
      label={label}
      onChange={onChange}
      value={selectedValue}
      placeholder={placeholder}
      className={label ? classes.customInputLabel : null}
      {...rest}>
      {map(items, (item, index) => (
        <MenuItem value={value ? item[value] : item} key={index}>
          {text ? item[text] : item}
        </MenuItem>
      ))}
    </Select>
  );
};

Dropdown.defaultProps = {
  text: '',
  value: '',
  items: [],
  placeholder: '',
  selectedValue: '',
};

Dropdown.propTypes = {
  text: PropTypes.string,
  items: PropTypes.array,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(Dropdown);
